import { commentsData } from '@/mocks/homeData';

export default function CommentsSection() {
  return (
    <section id="comments" className="py-14 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6 max-w-4xl mx-auto">
        <div className="text-center mb-10">
          <h2 className="font-heading text-2xl md:text-4xl text-foreground-950 mb-3">
            瓜友热评
          </h2>
          <p className="text-sm md:text-base text-foreground-500">
            百万瓜友的真实评价，看看大家都在聊什么
          </p>
        </div>

        <div className="space-y-4">
          {commentsData.map((comment) => (
            <div
              key={comment.id}
              className="bg-background-50 border border-background-200/70 rounded-xl p-4 md:p-5 flex gap-4"
            >
              <div className="w-10 h-10 md:w-11 md:h-11 flex-shrink-0 rounded-full overflow-hidden bg-background-100">
                <img
                  src={comment.avatar}
                  alt={comment.user}
                  className="w-full h-full object-cover"
                  loading="lazy"
                />
              </div>
              <div className="flex-1 min-w-0">
                <div className="flex items-center gap-2 mb-1 flex-wrap">
                  <span className="font-medium text-foreground-800 text-sm">{comment.user}</span>
                  <span className="text-xs text-foreground-400">{comment.time}</span>
                </div>
                <p className="text-sm text-foreground-600 leading-relaxed mb-2">
                  {comment.content}
                </p>
                <div className="flex items-center gap-1 text-xs text-foreground-400">
                  <i className="ri-thumb-up-line w-3.5 h-3.5 flex items-center justify-center"></i>
                  <span>{comment.likes}</span>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}